import React, { useEffect, useState } from "react";
import styles from "./Help.module.scss";

const Help = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1400);
  }, []);

  return (
    <div className={styles.acordian_title}>
      <h3>Help & Support</h3>
      <div className={styles.help_sec}>
        {loading ? (
          // Shimmer effect while loading
          <>
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className={`${styles.shimmer} shimmer`} />
            ))}
          </>
        ) : (
          // Embedding Help Desk inside an iframe
          <div className={styles.iframe_container}>
            <iframe
              src="https://www.stbl.io/helpdesk"
              width="100%"
              height="100%"
              style={{ border: "none", minHeight: "80vh" }}
              allow="fullscreen"
            ></iframe>
          </div>
        )}
      </div>
    </div>
  );
};

export default Help;
